import { selectors } from 'app-webtech-core';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import debug from 'debug';
import { APP_LOADED } from './types';
import { appLaunchTrack, setLaunchState, fetchWasabiExperiment } from '../../application/actions';
import { LAUNCH_STATE } from '../../application/constants';
import { SECTION_SELECT } from '../../layout/actions/types';

const logger = debug('core:application:actions:appLoaded');
const errorLogger = debug('core:application:actions:appLoaded:error');

const sectionSelect = actionCreator(SECTION_SELECT);
const appLoadedAction = actionCreator(APP_LOADED);

export const appLoadedThunkAction = () => async (dispatch, getState) => {
  const state = getState();
  const { appLoaded, uiLoaded, videoLoaded } = selectors.application.properties(state);

  if (!appLoaded && uiLoaded && videoLoaded) {
    const { section, previousSection } = selectors.layout.properties(state);
    if (!section) {
      const page = selectors.location.page(state) === 'Watch' ? 'live' : 'vod';
      const prevType = selectors.location.properties(state).prev.type;
      // eslint-disable-next-line no-nested-ternary
      const prevSection = prevType ? (prevType.includes('VOD') ? 'vod' : 'live') : 'na';
      const prevSectionToSend = prevSection !== page ? prevSection : 'na';
      dispatch(
        sectionSelect({
          section: page,
          previousSection: prevSectionToSend,
          doNotTrack: true,
        }),
      );
      dispatch(appLoadedAction({ section: page, previousSection: prevSectionToSend }));
    } else {
      dispatch(sectionSelect({ section, previousSection, doNotTrack: true }));
      dispatch(appLoadedAction({ section, previousSection }));
    }
    dispatch(appLaunchTrack(true));
    dispatch(setLaunchState(LAUNCH_STATE.APP_LOADED));

    const testData = await dispatch(fetchWasabiExperiment('web-first-test'));
    logger({ testData });
  } else if (process.env.NODE_ENV === 'development') {
    errorLogger('Invalid appLoaded dispatch');
  }
};
